import dom from "../../../dist/jsx-render/dom"
import { MsoTable } from "./MsoTable";
import { ListItem } from "../../Model/ListItem";
import { ColumnBool } from "./ColumnBool";
import { app } from "../../Frame/App";
import { ITableColumn } from "./ITableColumn";

export class ColumnStatusFinished extends ColumnBool {

    constructor(protected table: MsoTable, protected def: ITableColumn, protected rootId: string) {
        super(table, def, rootId);

        if (this.isEditable) {
            this.recreateCellOnUpdate = true;
        }
    }

    public createCell(rowModel: any, idField: string): HTMLElement {
        let cell = super.createCell(rowModel, idField);
        return cell;
    }

    protected initInlineEdit = (rowModel: any, idField: string, cell: HTMLElement) => {
        if (this.isEditable && rowModel[this.field] == false) {
            cell.classList.add("mt-textedit");

            let modelId = rowModel[idField];

            cell.addEventListener("click", () => {
                if (confirm(Resources.Common.columnStatusFinishedAsk)) {
                    app.showWaitPanel();
                    this.table.inlineEdit.saveValue(modelId, this.field, "true").done(() => {
                        app.hideWaitPanel();
                        cell.classList.add("mt-in-update");
                        this.table.updateRow(modelId, () => {
                            cell.classList.remove("mt-in-update");
                        });
                    }).fail(() => {
                        app.hideWaitPanel();
                    });;
                }
            });
        }
    }

}